import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/inserv-landing.css";

const services = [
  {
    title: "Клининг офисов и бизнес-центров",
    desc: "Ежедневная и генеральная уборка, поддержание имиджа и комфорта для сотрудников и гостей.",
  },
  {
    title: "Промышленные и складские объекты",
    desc: "Техника, спецсредства, требования безопасности и допуски для сложных помещений.",
  },
  {
    title: "Ритейл и ТРЦ",
    desc: "Высокие трафики, быстрая очистка зон, гибкие графики и ночные смены под мероприятия.",
  },
  {
    title: "После строительства и ремонта",
    desc: "Выводим объекты в состояние сдачи: без пыли, следов стройки и мелкого мусора.",
  },
  {
    title: "Сопутствующие услуги и снабжение",
    desc: "Подбор, закупка и хранение расходников и инвентаря; дезинфекция и спецработы.",
  },
];

const advantages = [
  {
    title: "Оптимизация затрат",
    desc: "Подбираем график и ресурсы под трафик объекта, убираем лишние часы и простои.",
  },
  {
    title: "Цифровой контроль",
    desc: "Чек-листы, фото-отчёты и SLA доступны онлайн, прозрачность по зонам и визитам.",
  },
  {
    title: "Обученная команда",
    desc: "Сертификация, допуски, стандарты безопасности и гигиены для каждого объекта.",
  },
  {
    title: "Быстрый старт",
    desc: "Запускаем объект за 24 часа после согласования объёма и графика.",
  },
];

const processSteps = [
  {
    title: "Заявка",
    desc: "Короткий бриф: тип объекта, метраж, график, особенности.",
  },
  {
    title: "Аудит и предложение",
    desc: "Оцениваем объект, предлагаем формат обслуживания и смету.",
  },
  {
    title: "Запуск",
    desc: "Назначаем команду, завозим инвентарь, фиксируем чек-листы и SLA.",
  },
  {
    title: "Контроль",
    desc: "Регулярные отчёты, фотофиксация, улучшения по данным.",
  },
];

const metrics = [
  { label: "Объектов в обслуживании", value: "> 120" },
  { label: "Специалистов в командах", value: "450+" },
  { label: "Ср. время реакции", value: "до 30 мин" },
  { label: "Удовлетворённость клиентов", value: "95%" },
];

const cases = [
  {
    title: "Офис 8 000 м²",
    desc: "Снизили расходы на 12% за счёт оптимизации графика и маршрутов, внедрили фото-отчётность.",
  },
  {
    title: "Склад и производство",
    desc: "Настроили ночные смены и спецуборку зон; SLA по отклику — до 20 минут.",
  },
  {
    title: "Ритейл и ТРЦ",
    desc: "Работаем с высокими трафиками, гибкие окна уборки и усиление команд под события.",
  },
];

const faqs = [
  {
    q: "Как быстро запускаете объект?",
    a: "Обычно в течение 24 часов после согласования объёма и доступа."
  },
  {
    q: "Какие средства и технику используете?",
    a: "Промышленные пылесосы, поломоечные машины, экосредства — подбираем под покрытие и требования."
  },
  {
    q: "Работаете ли ночью и 24/7?",
    a: "Да, формируем график под бизнес: ночные смены, усиления под мероприятия, круглосуточно."
  },
  {
    q: "Как устроен контроль качества?",
    a: "Чек-листы, фотофиксация, SLA по отклику, регулярные аудиты и отчёты в удобном формате."
  },
];

export default function InservLanding() {
  useEffect(() => {
    document.body.classList.add("landing-body");
    return () => document.body.classList.remove("landing-body");
  }, []);

  return (
    <div className="landing-page">
      <header className="landing-hero">
        <div className="landing-container hero-grid">
          <div className="hero-text">
            <p className="eyebrow">ИНСЕРВ — клининг и сопутствующие услуги</p>
            <h1>Инновационный сервис будущего</h1>
            <p className="lead">
              Клининг и сопутствующие услуги с цифровым контролем, прозрачной отчётностью и оптимизацией ваших затрат.
            </p>
            <div className="hero-actions">
              <a className="btn primary" href="tel:+74951234567">Позвонить</a>
              <Link className="btn ghost" to="/tmc-requests">Оставить заявку</Link>
            </div>
            <div className="hero-badges">
              <span>24/7 на объектах</span>
              <span>SLA и чек-листы в цифре</span>
              <span>Экологичные средства</span>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="hero-tag">Контроль</div>
              <h3>Цифровой чек-лист и фото-отчёт</h3>
              <p>Видите, что сделано, кто ответственный, и когда команда на смене.</p>
              <div className="hero-kpis">
                <div>
                  <strong>95%</strong>
                  <span>Удовлетворённость</span>
                </div>
                <div>
                  <strong>24/7</strong>
                  <span>Доступность</span>
                </div>
                <div>
                  <strong>30 мин</strong>
                  <span>Отклик</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="section services">
        <div className="landing-container">
          <div className="section-head">
            <p className="eyebrow">Услуги</p>
            <h2>Закрываем ключевые форматы клининга</h2>
            <p className="muted">От офисов и ритейла до складов, производства и послестройки — с гибкими графиками и спецсредствами.</p>
          </div>
          <div className="card-grid">
            {services.map((item) => (
              <div className="card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section advantages">
        <div className="landing-container">
          <div className="section-head">
            <p className="eyebrow">Почему мы</p>
            <h2>Оптимизируем затраты и даём прозрачность</h2>
            <p className="muted">Инновационный сервис — это не только экосредства и техника, но и данные, SLA и обученная команда.</p>
          </div>
          <div className="card-grid four">
            {advantages.map((item) => (
              <div className="card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section process">
        <div className="landing-container">
          <div className="section-head">
            <p className="eyebrow">Как работаем</p>
            <h2>Простой и прозрачный процесс</h2>
          </div>
          <div className="process-steps">
            {processSteps.map((step, idx) => (
              <div className="step" key={step.title}>
                <div className="step-index">0{idx + 1}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section metrics">
        <div className="landing-container metrics-grid">
          {metrics.map((m) => (
            <div className="metric" key={m.label}>
              <div className="metric-value">{m.value}</div>
              <div className="metric-label">{m.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section cases">
        <div className="landing-container">
          <div className="section-head">
            <p className="eyebrow">Кейсы</p>
            <h2>Результаты в цифрах</h2>
            <p className="muted">Примеры объектов, где мы снизили затраты и ускорили процессы без потери качества.</p>
          </div>
          <div className="card-grid three">
            {cases.map((item) => (
              <div className="card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section tech">
        <div className="landing-container tech-grid">
          <div className="tech-text">
            <p className="eyebrow">Технологии и контроль</p>
            <h2>Данные, отчётность и экосредства</h2>
            <p className="muted">Чек-листы, фотофиксация, SLA, аудиты. Интеграции с 1С/Bitrix24, уведомления в почту и мессенджеры. Экологичные средства и правильный подбор инвентаря под покрытие.</p>
            <ul className="bullets">
              <li>SLA и KPI в цифрах</li>
              <li>Фото- и видео-отчёты по зонам</li>
              <li>История визитов и работ онлайн</li>
            </ul>
          </div>
          <div className="tech-card">
            <div className="tech-badge">Прозрачность</div>
            <h3>Что сделано — видно</h3>
            <p>Каждый визит фиксируется: время, зона, исполнитель и подтверждение в фото.</p>
          </div>
        </div>
      </section>

      <section className="section faq">
        <div className="landing-container">
          <div className="section-head">
            <p className="eyebrow">FAQ</p>
            <h2>Частые вопросы</h2>
          </div>
          <div className="faq-list">
            {faqs.map((item) => (
              <details key={item.q}>
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="section cta">
        <div className="landing-container cta-inner">
          <div>
            <p className="eyebrow">Свяжитесь с нами</p>
            <h2>Обсудим ваш объект и предложим оптимизацию без потери качества</h2>
            <p className="muted">Работаем по SLA, предоставляем отчёты, подбираем команду и средства под ваши задачи.</p>
            <div className="cta-actions">
              <a className="btn primary" href="tel:+74951234567">Позвонить</a>
              <Link className="btn ghost" to="/tmc-requests">Оставить заявку</Link>
            </div>
          </div>
          <div className="cta-card">
            <div className="cta-line">
              <span>Телефон</span>
              <a href="tel:+74951234567">+7 (495) 123-45-67</a>
            </div>
            <div className="cta-line">
              <span>Почта</span>
              <a href="mailto:info@inserv.msk.ru">info@inserv.msk.ru</a>
            </div>
            <div className="cta-line">
              <span>Мессенджеры</span>
              <a href="https://t.me/">Telegram</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
